import { observer } from "mobx-react"
import * as React from "react"
import { GeneralStep } from "./GeneralStep"
import { Flex, Text } from "rebass"
import Input from "../../components/Input"
import theme from "../../theme"
import InputWrapper from "../../components/InputWrapper"
import InputLabel from "../../components/InputLabel"
import styled from "styled-components"

@observer
export class General extends React.Component<{
  model: GeneralStep
}> {
  render() {
    const { model } = this.props

    const StyledInputWrapper = styled(InputWrapper)`
      width: 75%;
      height: 80px;
      background: ${theme.colors.white};
      :focus-within {
        border: solid 1px ${theme.colors.white};
      }
    `
    return (
      <Flex
        justifyContent={["center"]}
        alignItems={["center"]}
        flexDirection={["column"]}
        bg={theme.colors.black}
        p={4}
        width={["95vw", "70vw"]}
        style={{ height: "50vh" }}
      >
        <Text
          fontSize={["1rem", "1.5rem"]}
          style={{
            fontFamily: theme.fonts.secondary,
            color: theme.colors.text,
            textTransform: "uppercase"
          }}
        >
          To Get Started
        </Text>
        <Text
          mb={"3.5%"}
          fontSize={["1.5rem", "2.5rem"]}
          style={{
            fontFamily: theme.fonts.primary,
            color: theme.colors.text,
            textTransform: "uppercase"
          }}
        >
          Enter Your Phone #
        </Text>
        <Flex
          justifyContent="center"
          alignItems="center"
          style={{
            minHeight: "10%",
            minWidth: "75%",
            backgroundColor: theme.colors.interactiveBackground,
            margin: "2%"
          }}
        >
          <StyledInputWrapper
            style={{ height: window.innerWidth > 450 ? 80 : 40 }}
          >
            <InputLabel
              style={{
                color: theme.colors.grey,
                background: "transparent"
              }}
            >
              Phone Number
            </InputLabel>
            <Input
              autoFocus
              style={{
                height: window.innerWidth > 450 ? 75 : 36,
                fontSize: window.innerWidth > 450 ? "1.5rem" : "1rem",
                width: "100%",
                paddingLeft: "8%"
              }}
              type="tel"
              placeholder="(000) 000-0000"
              onChange={event => {
                model.phone = event.target.value
              }}
            />
          </StyledInputWrapper>
          <Flex
            className="start"
            width={["30%", "25%"]}
            justifyContent="center"
            alignItems="center"
            bg={theme.colors.callToAction}
            style={{
              height: window.innerWidth > 450 ? 80 : 40,
              textTransform: "uppercase",
              fontFamily: theme.fonts.primary,
              color: theme.colors.text,
              letterSpacing: 2,
              alignSelf: "flex-end"
            }}
            onClick={() => model.editNewMember(model.phone)}
          >
            Start
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
